<template>
  <div>
    <!-- Scan to Earn Modal -->
    <modal
      name="loyaltyScanModal"
      modal-style="compact"
      :display-header-title="false"
    >
      <scan-to-earn />
    </modal>

    <!-- Scan to learn more modal -->
    <modal
      name="learnMore"
      modal-style="compact"
    >
      <scan-to-learn-more />
    </modal>

    <!-- SCAN TO CHECK IN BARCODE MODAL -->
    <modal
      name="barcodeScanner"
      modal-style="compact"
    >
      <barcode-scanner />
    </modal>

    <!-- MANUAL ENTRY CHECK IN BARCODE MODAL -->
    <modal
      name="manualBarcodeEntry"
      modal-style="compact"
    >
      <manual-barcode-entry />
    </modal>

    <!-- REFER A FRIEND MODAL -->
    <modal
      name="referFriends"
      modal-style="compact"
    >
      <refer-a-friend />
    </modal>
  </div>
</template>


<script>
  import ScanToEarn from './scan-to-earn/index.vue';
  import ManualBarcodeEntry from './manual-barcode-entry/index.vue';
  import ScanToLearnMore from './scan-to-learn-more/index.vue';
  import BarcodeScanner from './barcode-scanner/index.vue';
  import ReferAFriend from './refer-a-friend/index.vue';


  export default {
    name: 'LoyaltyScanningModals',

    components: {
      ScanToEarn,
      ScanToLearnMore,
      BarcodeScanner,
      ManualBarcodeEntry,
      ReferAFriend
    }
  };
</script>
